import { getAppointmentAvailability } from "api/clinician";
import { useQuery } from "react-query";

/**
 * Custom hook to fetch appointment availability for a clinician.
 *
 * @param {string[]} clinicianUserIds - Array of clinician user IDs.
 * @param {string} serviceType - The type of service (this is optional BE has a default value for this parameter).
 * @param {number} callDuration - The duration of the appointment call.
 * @param {string} startDate - The start date of the availability range in format "YYYY-MM-DD".
 * @param {string} endDate - The end date of the availability range in format "YYYY-MM-DD".
 * @returns {Object} - The result of the useQuery hook.
 */
export function useGetAppointmentAvailability(
  clinicianUserIds: string[],
  callDuration: number,
  startDate: string | null,
  endDate: string | null
) {
  return useQuery(
    ["clinicianAvailableHours", clinicianUserIds, callDuration, startDate, endDate],
    () =>
      getAppointmentAvailability(clinicianUserIds, {
        startDate,
        endDate,
        duration: callDuration,
      }),
    {
      enabled: !!clinicianUserIds && !!startDate && !!endDate && !!callDuration,
    }
  );
}
